// store/bannerStaticStore.ts
import { create } from "zustand";

type LangContent = {
  en: string;
  id: string;
};

export type BannerStatic = {
  title: LangContent;
  sub_title: LangContent;
  slug: string;
  image_desktop: string;
  image_mobile: string;
  button_url: string;
};

type BannerStaticStore = {
  bannerStatic: BannerStatic | null;
  fetchBannerStatic: (lang: "en" | "id") => Promise<void>;
};

const baseUrl = "https://admin.talentlinkindo.com/api";

export const useBannerStaticStore = create<BannerStaticStore>((set) => ({
  bannerStatic: null,

  fetchBannerStatic: async (lang) => {
    try {
      const res = await fetch(`${baseUrl}/${lang}/our-service/banner`);
      if (!res.ok) throw new Error("Failed to fetch banner static");

      const json = await res.json();

      // 🔑 sesuai response API
      set({ bannerStatic: json.banners || null });
    } catch (error) {
      console.error("Failed to fetch banner static:", error);
    }
  },
}));